import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult, CatDetails, CatList } from '../../types';
import Cache from '../cache/cache';

export default async function getCategoryTree(context: Context, params: CustomQuery): Promise<ApiResult> {
  const cacheKey = 'getCategoryTree_' + JSON.stringify(params);
  const cacheData = Cache.getCache(context, cacheKey);
  if (cacheData) {
    return cacheData;
  }

  const url = new URL('/mall/cat/tree', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  const CatListData = [];
  if (res.code === 0) {
    const result = res.data;
    if (result && result.list) {
      result.list.forEach((x) => {
        const catInfo: CatList = {
          catId: x.cat_id,
          shopId: x.shop_id,
          name: x.name,
          pCatId: x.p_cat_id,
          weight: x.weight,
          imageUrl: '',
          count: x.count,
          slug: x.slug,
          subCats: []
        };
        if (x.sub_cats) {
          x.sub_cats.forEach((y) => {
            const subCatInfo: CatDetails = {
              catId: y.cat_id,
              shopId: y.shop_id,
              name: y.name,
              pCatId: y.p_cat_id,
              weight: y.weight,
              imageUrl: '',
              count: y.count,
              slug: y.slug,
              isSub: y.is_sub,
            };
            catInfo.subCats.push(subCatInfo);
          });
        }
        CatListData.push(catInfo);
      });
    }
  }
  res.data = CatListData;
  Cache.setCache(context, cacheKey, res);
  return res;
}
